import {
  SET_OPERATION_PROPERTY,
  UPDATE_OPERATION_DATA,
  SET_PATCH_OPERATION_FIELD,
  PROSPECT_TRANSFORM_PATCH_OPERATION,
  UPDATE_OPERATION_PROSPECT_TO_BBVA
} from 'store/actions/operation';
import { dateToString, changeFormatFromBBVA, dateToISO } from 'helpers/date';
import { fetchFromObject, setValueObjectByField } from 'helpers/object';
import { DATA_OPERATION, DOCUMENT_TYPES } from 'store/enums';
import validateSpanishId from '@/validators/rules/validateSpanishId';

export default {
  [SET_OPERATION_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
    // Check single field
    const lastIndex = field.lastIndexOf('.');
    const pathFielName = field.substring(0, lastIndex);
    const fieldName = field.substring(lastIndex + 1, field.length);
    // Condition for fields equal to some value
    // Equals postalCode field
    if (fieldName === 'postalCode') {
      setValueObjectByField(state, `${pathFielName}.provinceCode`, value.substring(0, 2));
    }
    // Equals documentId field
    if (fieldName === 'documentId') {
      const { type, valid } = validateSpanishId(value.toUpperCase());
      if (valid) {
        setValueObjectByField(
          state,
          `${pathFielName}.documentType`,
          DOCUMENT_TYPES[type.toUpperCase()]
        );
      }
    }
  },

  [UPDATE_OPERATION_DATA]: (state, operation) => {
    const { customerType, flux, prospect, signRequest } = operation;
    state.operationFromAPI = true;
    state.customerType = customerType;
    state.flux = flux;
    state.signRequest = signRequest;
    if (prospect) {
      prospect.contact.forEach(element => {
        /* eslint-disable no-param-reassign */
        element.documentType = element.documentType.toString();
        element.birthDate = dateToString(element.birthDate);
        if (element.driverLicenseIssuedDate)
          element.driverLicenseIssuedDate = dateToString(element.driverLicenseIssuedDate);
      });
      state.prospect = prospect;
    }
  },

  [UPDATE_OPERATION_PROSPECT_TO_BBVA]: (state, bbvaClient) => {
    state.prospect.contact[0] = {
      contactType: DATA_OPERATION.CONTACT_TYPE.CONTACT,
      documentId: bbvaClient.identityDocument[0].number,
      documentType: bbvaClient.identityDocument[0].type,
      name: bbvaClient.firstName,
      lastname: bbvaClient.surname,
      lastname2: bbvaClient.secondSurname,
      genre: bbvaClient.sex,
      address: {
        streetType: bbvaClient.addresses[0].streetType,
        address1: `${bbvaClient.addresses[0].streetName} ${bbvaClient.addresses[0].streetNumber} ${bbvaClient.addresses[0].floor}${bbvaClient.addresses[0].door} ${bbvaClient.addresses[0].additionalData}`,
        postalCode: bbvaClient.addresses[0].zipcode,
        provinceCode: bbvaClient.addresses[0].zipcode.substring(0, 2)
      },
      email: bbvaClient.email,
      mobile: bbvaClient.phone,
      birthDate: changeFormatFromBBVA(bbvaClient.birthdate)
    };
  },

  // eslint-disable-next-line complexity
  [SET_PATCH_OPERATION_FIELD]: (state, { field, value }) => {
    const originalValue = fetchFromObject(state, field);
    const path = field.replace(/\./g, '/');
    const pathWithoutFielName = path.substring(0, path.lastIndexOf('/'));
    const fieldName = path.substring(path.lastIndexOf('/') + 1, path.length);
    if (state.patchOperation === undefined) state.patchOperation = {};
    if (value && (originalValue !== value || fieldName === 'cityCode')) {
      state.patchOperation[`/${path}`] =
        fieldName === 'bankAccount'
          ? value
              .replace(/\s/g, '')
              .trim()
              .toUpperCase()
          : value;
      if (fieldName === 'postalCode' && value.length >= 2) {
        state.patchOperation[`/${pathWithoutFielName}/provinceCode`] = value.substring(0, 2);
      }
      if (fieldName === 'documentId') {
        const { type, valid } = validateSpanishId(value.toUpperCase());
        if (valid) {
          state.patchOperation[`/${pathWithoutFielName}/documentType`] =
            DOCUMENT_TYPES[type.toUpperCase()];
        }
      }
    } else {
      delete state.patchOperation[`/${path}`];
      if (fieldName === 'postalCode') {
        delete state.patchOperation[`/${pathWithoutFielName}/provinceCode`];
      } else if (fieldName === 'documentId') {
        delete state.patchOperation[`/${pathWithoutFielName}/documentType`];
      }
    }
  },

  [PROSPECT_TRANSFORM_PATCH_OPERATION]: state => {
    const patchOperationToSend = [];
    if (state.patchOperation) {
      Object.keys(state.patchOperation).forEach(path => {
        let value = state.patchOperation[path];
        if (/birthDate|driverLicenseIssuedDate/.test(path)) value = dateToISO(value);
        patchOperationToSend.push({
          op: 'add',
          path,
          value
        });
      });
    }
    state.patchOperationToSend = patchOperationToSend;
  }
};
